import styled from 'styled-components';

export const OfferOuterWrap = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: ${props.theme.spacing.small};
    background-color: ${props.theme.colors.goYellow.light};
    border-radius: ${props.theme.misc.borderRadius.base};
    margin-top: ${props.theme.spacing.custom(4)};
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    align-self: flex-end;
  `,
);

export const OfferInfoText = styled.p(
  props => `
        padding-left: ${props.theme.spacing.xsmall};
        font-size: ${props.theme.font.small};
        color: ${props.theme.colors.goZest.dark};
    `,
);

// HOVER STUFF

export const HiddenDropdownWrapperDiv = styled.div`
  width: ${props => props.width || '30rem'};
  bottom: 1.5rem;
  right: 0;
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  right: ${props => props.right};
  left: ${props => props.left};
  max-width: ${props => props.width || '30rem'};
  padding: ${props => props.theme.spacing.base} 0;
  z-index: ${props => props.theme.misc.zIndex.base};
  /* display: none; */
  transition: opacity 0.8s;
  position: absolute;
`;

export const HoverTargetWrapperDiv = styled.div`
  position: relative;
  text-align: left;
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
  cursor: pointer;
  /* &:hover > ${HiddenDropdownWrapperDiv} {
    display: block;
  } */
`;

export const TopDiv = styled.div(
  props => `
background-color: ${props.theme.colors.goWhite.base};
border-radius: ${props.theme.misc.borderRadius.base};
box-shadow: 0 ${props.theme.spacing.xxsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.base
  };
`,
);

const TipUI = styled.div`
  position: absolute;
  margin-left: -${props => props.theme.spacing.base};
  width: 2.4rem;
  height: 1.2rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
  }
`;

export const TipPositioning = styled(TipUI)`
  bottom: -0.2rem;
  right: 15%;
  top: ${props => props.top};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  right: ${props => props.right};
  &::after {
    transform: translate(-50%, -50%) rotate(45deg);
    transform: ${props => props.transform};
    background: white;
    box-shadow: 0 ${props => props.theme.spacing.xxsmall} ${props => props.theme.spacing.custom(4)}
      ${props => props.theme.colors.shadow.base};
  }
`;

//

export const OfferBlockConatiner = styled.div(
  props => `
    width:31rem;
    background-color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.small};
    box-shadow: 0 ${props.theme.spacing.xsmall} ${props.theme.spacing.custom(4)} ${
    props.theme.colors.shadow.light
  };
  `,
);

export const OfferBlockInnerContainer = styled.div(
  props => `

  display:flex;
  border-bottom: 1px solid ${props.theme.colors.goBrandBlue.light};
  &:last-child {
    border-bottom: none;
  };
  padding:${props.theme.spacing.large};
  `,
);

export const OfferBlockWrap = styled.div(
  props => `

  margin-right:${props.theme.spacing.base};

  `,
);

export const OfferBlocklabel = styled.span(
  props => `

  font-size: ${props.theme.font.custom(14)};
  font-weight:bold;
  
  `,
);

export const PreAppliedWrap = styled.span(
  props => `
  color: ${props.theme.colors.goGreen.base};
  background-color: ${props.theme.colors.goGreen.dark};
  padding: 0 ${props.theme.spacing.small};
  border-radius:${props.theme.misc.borderRadius.xxlarge};
  `,
);

export const PromoLabel = styled.span(
  props => `

  font-size: ${props.theme.font.custom(14)};
  
  `,
);

export const OfferDescription = styled.p(
  props => `
  color: ${props.theme.colors.downriver.dark};
  margin-top:${props.theme.spacing.small};
  `,
);

export const OfferSubDescription = styled.p(
  props => `
  color: ${props.theme.colors.downriver.medium};
  `,
);

export const UnlockOffer = styled.a(
  props => `

  font-size: ${props.theme.font.small};
  color: ${props.theme.colors.goBrandBlue.base};
  cursor:pointer;
  margin-top:${props.theme.spacing.small};
  `,
);
